export const conferences = [
  { name: "QuantMinds International", year: "2024", location: "London" },
  { name: "QuantMinds International", year: "2023", location: "London" },
  {
    name: "International Symposium on Advances in Metallurgy",
    year: "2024",
    note: "Best Research Poster",
  },
  { name: "TMS Annual Meeting", year: "2024" },
  { name: "AMMS · Advances in Materials and Manufacturing Science", year: "2023" },
  { name: "EMMC · European Mechanics of Materials Conference", year: "2022" },
  { name: "New Frontiers in Materials Design", year: "2022" },
];
